import React from "react";
import { Modal } from "react-bootstrap";

// project-import
import {
  GoogleAnalyticsEnum,
  pageView,
  triggerFunction,
} from "../../utils/google-analytics";
import { PAISE } from "../../constants/entityType";

// third-party
import { FaCircleCheck } from "react-icons/fa6";

export const PaymentSuccessModel = ({
  show,
  onCloseModal,
  title = "Payment Successful!",
  // amount,
  // orderId,
  response,
}) => {
  
  // const handleMasked = (transaction, visibleChar = 4, maskChar = "*") => {
  //   try {
  //     if (transaction && transaction.length <= visibleChar) {
  //       return transaction;
  //     }

  //     const visiblePart = transaction.slice(-visibleChar);
  //     const maskedPart = transaction.length - visibleChar;

  //     const masked = maskChar.repeat(maskedPart);

  //     return masked + visiblePart;
  //   } catch (error) {
  //     console.log("error while masking id", error);
  //   }
  // };

  // Constant Variables
  const amount =
    response?.amountUnit === PAISE
      ? response?.amount / 100
      : response?.amount || 0.0;
  const orderId = response?.notes && response?.notes.length && (response?.notes[0]?.id || "");
  const productCode =
    response?.notes &&
    response?.notes.length &&
    (response?.notes[0].productCode || "");
  const paymentId =
    response && (response?.paymentId || "");
  const vendorName = response && (response?.vendorName || "Longswitch Academy");

  return (
    <>
      {pageView(
        window.location.href,
        GoogleAnalyticsEnum.SALESFORCE_PRICING_SUCCESS_ALERT_OPENED
      )}
      <div>
        <Modal
          className="rounded-lg"
          show={show}
          onHide={() => {
            onCloseModal();
            triggerFunction(
              window.location.href + GoogleAnalyticsEnum.BUTTON,
              GoogleAnalyticsEnum.SALESFORCE_PRICING_SUCCESS_ALERT_CLOSED
            );
          }}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          size="md"
        >
          <Modal.Header className="py-5 pb-0 border-0">
            {" "}
            {/** Remove closeButton as for now raj */}
            <Modal.Title
              as={"h4"}
              className="mb-0 display-4 text-center w-100 text-success"
            >
              <FaCircleCheck size={"4rem"} className="me-3" />
              <h5 className="text-success mb-0">{title}</h5>
              <p className="fs-4 mb-0">Successfully Paid Rs.{amount}</p>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="pb-4 px-4">
            <div className="container p-2">
              <h5 className="py-1 fs-2 text-start mb-0 text-capitalize">
                Payment details
              </h5>
              <hr className=" border-2 boder-bottom p-0 m-2"></hr>
              <div className="justify-content-center">
                <div className="col-12 col-sm-12 fw-semibold text-muted text-start">
                  <div className="row py-1">
                    <div className="col-12 col-sm-4 fs-4 text-heading">Order Id :</div>
                    <div className="col-12 col-sm-8 text-end fs-4 text-break text-value">
                      {orderId}
                    </div>
                  </div>
                  <div className="row py-1">
                    <div className="col-12 col-sm-4 fs-4 text-heading">Product Code :</div>
                    <div className="col-12 col-sm-8 text-end fs-4 text-break text-value">
                      {productCode}
                    </div>
                  </div>
                  <div className="row py-1">
                    <div className="col-12 col-sm-4 fs-4 text-heading">Vender Name :</div>
                    <div className="col-12 col-sm-8 text-end fs-4 text-break text-value">
                      {vendorName}
                    </div>
                  </div>
                  {/* <div className="row py-1">
                    <div className="col-12 col-sm-4 fs-4 text-heading">Payment Method :</div>
                    <div className="col-12 col-sm-8 text-end fs-4 text-uppercase text-break">
                      {paymentMethod}
                    </div>
                  </div> */}
                  {/* <div className="row py-1">
                    <div className="col-12 col-sm-4 fs-4 text-heading">UPI Id :</div>
                    <div className="col-12 col-sm-8 text-end fs-4 text-break">
                      {paymentMethodId}
                    </div>
                  </div> */}
                  <div className="row py-1">
                    <div className="col-12 col-sm-4 fs-4 text-heading">Transaction Id :</div>
                    <div className="col-12 col-sm-8 text-end text-break fs-4 text-value">
                      {paymentId || ""}
                    </div>
                  </div>
                  {/* <div className="row py-1">
                    <div className="col-12 col-sm-4 fs-4 text-heading">Payment Time :</div>
                    <div className="col-12 col-sm-8 text-end fs-4">{`9:00 PM`}</div>
                  </div> */}

                  {/* <div className="row py-1">
                    <div className="col-12 col-sm-4 fs-4 text-heading">Payment Date :</div>
                    <div className="col-12 col-sm-8 text-end fs-4 text-break">
                      {paymentDate}
                    </div>
                  </div> */}
                  <div className="row py-1">
                    <div className="col-12 col-sm-4 fs-4 text-heading">Total Amount :</div>
                    <div className="col-12 col-sm-8 text-end fs-4 text-break text-value">
                      ₹ {amount}
                    </div>
                  </div>
                </div>
              </div>
              <hr className=" border-2 boder-bottom p-0 m-2"></hr>
            </div>

            {/* Buttons */}
            <div className="d-flex justify-content-center gap-3 mt-4">
              <button
                className="edu-btn purchase-btn btn-small"
                onClick={onCloseModal}
              >
                Okay
              </button>

              {/* <button
                className="edu-btn purchase-btn btn-small"
                onClick={() => copy_to_clipboard(paymentId)}
              >
                Copy ID
              </button> */}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};
